import baseUrl from './baseUrl';

const URL_GET_CATEGORIAS = `${baseUrl}/categoria`;

const getCategorias = async () => {
  try {
    const data = await fetch(URL_GET_CATEGORIAS, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getCategorias;
